module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/7382ef4a40ab40e4fec38b912a5c9ad7.png";